module.exports = __webpack_public_path__ + "static/media/listening_image3.6a2a67c6.webp";